import React from "react";

const GoogleIcon = () => {
  return (
    <div>
      <svg
        width="30"
        height="25"
        viewBox="0 0 18 18"
        fill="none"
        className="google-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.48 9.15339C15.48 8.67475 15.437 8.21452 15.3573 7.77271H9V10.3837H12.6327C12.4763 11.2275 12.0007 11.9424 11.2858 12.421V14.1146H13.4673C14.7436 12.9395 15.48 11.2091 15.48 9.15339Z"
          fill="#4285F4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9 15.75C10.8225 15.75 12.3505 15.1455 13.4673 14.1146L11.2858 12.421C10.6814 12.826 9.90818 13.0653 9 13.0653C7.24193 13.0653 5.75387 11.8779 5.22307 10.2825H2.96796V12.0313C4.07864 14.2374 6.36137 15.75 9 15.75Z"
          fill="#34A853"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.22307 10.2825C5.08807 9.87749 5.01136 9.44488 5.01136 8.99999C5.01136 8.55511 5.08807 8.12249 5.22307 7.71749V5.96863H2.96795C2.5108 6.87988 2.25 7.91079 2.25 8.99999C2.25 10.0892 2.5108 11.1201 2.96795 12.0314L5.22307 10.2825Z"
          fill="#FBBC05"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9 4.93466C9.99102 4.93466 10.8808 5.27523 11.5803 5.94409L13.5164 4.00807C12.3474 2.91886 10.8194 2.25 9 2.25C6.36137 2.25 4.07864 3.76261 2.96796 5.96864L5.22307 7.7175C5.75387 6.12205 7.24193 4.93466 9 4.93466Z"
          fill="#EA4335"
        />
      </svg>
    </div>
  );
};

export default GoogleIcon;
